import type { UserBillingInfo } from '../../contracts';

export type CreditAllowanceThresholdBillingPlanInfo = Pick<
  UserBillingInfo,
  'seat_type' | 'new_product_tier'
>;

/** True when tier and seat are both present — safe to key consumption storage. */
export function isCreditAllowanceThresholdBillingPlanResolved(
  billingInfo: CreditAllowanceThresholdBillingPlanInfo | null | undefined
): billingInfo is CreditAllowanceThresholdBillingPlanInfo {
  return billingInfo?.new_product_tier != null && billingInfo?.seat_type != null;
}

/** Tier + seat for threshold consumption keys (Clinician Max = CLINICIAN_PRO + MAX). */
export function getCreditAllowanceThresholdBillingPlanKey(
  billingInfo: CreditAllowanceThresholdBillingPlanInfo
): string {
  return `${billingInfo.new_product_tier}:${billingInfo.seat_type}`;
}
